import userHome from "../../Assets/images/userHome.png";
import Home1 from "../../Assets/images/home1.png";
export const CreatorsArray = [
  {
    id: 1,
    title: "ETH never die",
    mainImg: Home1,
    img1: userHome,
    img2: userHome,
    price: 0.25,
    item: "1 of 12",
  },
  {
    id: 2,
    title: "Future Coming Soon",
    mainImg: Home1,
    img1: userHome,
    img2: userHome,
    price: 0.27,
    item: "1 of 20",
  },
  {
    id: 3,
    title: "Elon Musk silver coin 3d print",
    mainImg: Home1,
    img1: userHome,
    img2: userHome,
    price: 0.27,
    item: "1 of 12",
  },
];

export const LatestUpdatesArray = [
  {
    id: 1,
    title: "payton harris",
    price: 2.45,
  },
  {
    id: 2,
    title: "Anita Bins",
    price: 2.45,
  },
  {
    id: 3,
    title: "Janna Wackert",
    price: 2.456,
  },
  {
    id: 4,
    title: "Ledner Lorena",
    price: 2.45,
  },
];
